import React from 'react';
import {
  FaSprayCan,
  FaCouch,
  FaBug,
  FaBed,
  FaThLarge,
  FaBroom,
  FaBuilding,
} from 'react-icons/fa';

const services = [
  {
    id: 1,
    name: 'Pest Control',
    slug: 'pest-control-brisbane',
    icon: FaBug,
    shortDescription: 'Safe and effective pest treatment for homes and businesses across Brisbane.',
    description:
      'Our pest control service targets common pests including cockroaches, ants, spiders, and rodents using approved treatment methods. We assess infestation severity, apply targeted treatment, and provide practical prevention advice to keep your property protected long term.',
    features: [
      'Home and commercial treatments',
      'Safe family-friendly pest solutions',
      'Cockroach, ant, spider and rodent control',
      'Entry-point inspection and advice',
      'Targeted treatment plans',
      'Follow-up support',
    ],
    image: '/service-preview-img/PestControl.jpg',
  },
  {
    id: 2,
    name: 'Tile and Grout Cleaning',
    slug: 'tile-and-grout-cleaning-brisbane',
    icon: FaThLarge,
    shortDescription: 'Deep cleaning for tiled surfaces and grout lines to restore brightness and hygiene.',
    description:
      'Tiles and grout naturally collect grime, mould, and bacteria over time. Our tile and grout cleaning service uses professional equipment to lift embedded dirt from grout lines and restore tiled areas in kitchens, bathrooms, and high-traffic zones. We finish with optional sealing recommendations to help maintain results for longer.',
    features: [
      'High-pressure grout line cleaning',
      'Mould and mildew reduction',
      'Kitchen and bathroom tile restoration',
      'Slip-safe cleaning methods',
      'Stain removal on most tile surfaces',
      'Optional grout protection guidance',
    ],
    image: '/service-preview-img/TileAndGrout.jpg',
  },
  {
    id: 6,
    name: 'Apartment/Unit Cleaning',
    slug: 'apartment-cleaning-brisbane',
    icon: FaBuilding,
    shortDescription: 'Detailed apartment and unit cleaning for spotless living spaces and move-in ready results.',
    description:
      'A clean home is a healthier, more comfortable place to live, and our professional apartment and unit cleaning services are tailored to suit your lifestyle—whether you need a one-off refresh or regular, ongoing care. From everyday tidying to detailed move-in and move-out cleans, our experienced team pays attention to every detail, ensuring reliable, high-quality results for any size property and complete customer satisfaction.',
    features: [
      'Public Area Cleaning',
      'Deep Cleaning',
      'Move-In & Move-Out Cleaning',
      'Common Area Cleaning',
      'Window cleaning & Kitchen Cleaning',
      'Bathroom Cleaning & Sanitisation',
      'Bedroom & Living Area Cleaning',
      'Dusting All Accessible Surfaces',
      'Vacuuming & Mopping Floors',
      'Internal Window & Glass Cleaning',
      'Cobweb Removal',
      'Rubbish Bin Emptying',
      'Skirting Boards & Door Frame Cleaning',
      'Customised Cleaning Plans to Suit Your Needs',
    ],
    image: '/service-preview-img/Apartment-Preview.jpg',
  },
  {
    id: 3,
    name: 'Carpet Cleaning',
    slug: 'carpet-cleaning-brisbane',
    icon: FaSprayCan,
    shortDescription: 'Deep steam cleaning to remove dirt, stains, and allergens from your carpets.',
    description:
      'Our professional carpet steam cleaning service uses high-temperature steam to penetrate deep into carpet fibres, removing embedded dirt, stubborn stains, allergens, and bacteria. We use eco-friendly cleaning solutions that are safe for children and pets while delivering exceptional results. Our experienced technicians ensure your carpets look fresh, feel soft, and smell clean.',
    features: [
      'Hot water extraction method',
      'Eco-friendly cleaning solutions',
      'Stain and odour removal',
      'Fast drying time',
      'Safe for children and pets',
      'Extends carpet lifespan',
    ],
    image: '/service-preview-img/CarpetCleaning.webp',
  },
  {
    id: 4,
    name: 'Couch Cleaning',
    slug: 'couch-cleaning-brisbane',
    icon: FaCouch,
    shortDescription: 'Professional upholstery cleaning to refresh and sanitise your couches and sofas.',
    description:
      'Your couch is the centrepiece of your living room and deserves professional care. Our couch steam cleaning service deep cleans upholstery, removing stains, odours, dust mites, and bacteria. We treat all types of upholstery fabrics with appropriate cleaning methods to restore their appearance and freshness.',
    features: [
      'Deep stain removal',
      'Fabric protection treatment',
      'Allergen and bacteria elimination',
      'Odour neutralisation',
      'Quick drying process',
      'All upholstery types covered',
    ],
    image: '/service-preview-img/CouchCleaning.webp',
  },
  {
    id: 5,
    name: 'End of Lease Cleaning(Bond Cleaning)',
    slug: 'end-of-lease-cleaning-brisbane',
    icon: FaBroom,
    displayName: 'Bond Cleaning',
    shortDescription: 'Detailed cleaning designed to help you secure your bond return.',
    description:
      'Our professional end of lease cleaning (bond cleaning) ensures your rental property is left in pristine condition. We follow a comprehensive checklist designed to meet real estate standards, helping you secure your full bond refund with confidence.',
    features: [
      ['Maximising Your ', <strong key="bond-feature">Bond</strong>, ' Return'],
      'Kitchen, bathroom, and bedroom deep clean',
      'Oven and appliance cleaning included',
      'Comprehensive checklist matching agency standards',
      'Experienced and fully equipped cleaners',
      'Before and after photos provided',
    ],
    image: '/service-preview-img/Bond-Preview.jpg',
  },
  {
    id: 7,
    name: 'Mattress Cleaning',
    slug: 'mattress-cleaning-brisbane',
    icon: FaBed,
    shortDescription: 'Thorough mattress cleaning and sanitisation for a healthier sleep environment.',
    description:
      'A clean mattress is essential for good health and quality sleep. Our mattress cleaning service eliminates dust mites, bacteria, sweat stains, and allergens that accumulate over time. We use specialised steam cleaning equipment and sanitising agents to deep clean your mattress without harsh chemicals.',
    features: [
      'Dust mite elimination',
      'Stain and odour removal',
      'Anti-bacterial treatment',
      'Hypoallergenic cleaning',
      'UV sanitisation available',
      'All mattress sizes and types',
    ],
    image: '/service-preview-img/Mattress.webp',
  },
];

export default services;